// Genel kullanım için description ve keywords değerlerini değiştirebilirsiniz.

const description =
  "4nala.com , eşsiz at yarışı deneyimi sunar. at yarışı sonuçları, at yarışı programı, hipodromlar ve daha fazlası için hemen ziyaret edin.";
const keywords =
  "at yarışı, at yarışı sonuçları, at yarışı programı, hipodrom, jokey, at, yarış, 4nala";

const paths: any = {
  home: {
    url: "/",
    title: "4NALA.COM, AT YARIŞI, BAHİS, AT YARIŞI SONUÇLARI, HİPODROM, AT YARIŞI PROGRAMI",
    description:
      "4nala.com , eşsiz at yarışı deneyimi sunar. at yarışı sonuçları, at yarışı programı, hipodromlar ve daha fazlası için hemen ziyaret edin.",
    keywords:
      "at yarışı, at yarışı sonuçları, at yarışı programı, hipodrom, jokey, at, yarış, 4nala",
  },
  login: {
    url: "/giris-yap",
    title: "GİRİŞ YAP - 4NALA.COM, AT YARIŞI, BAHİS, AT YARIŞI SONUÇLARI, HİPODROM, AT YARIŞI PROGRAMI",
    description:
      "4nala.com , eşsiz at yarışı deneyimi sunar. at yarışı sonuçları, at yarışı programı, hipodromlar ve daha fazlası için hemen ziyaret edin.",
    keywords:
      "at yarışı, at yarışı sonuçları, at yarışı programı, hipodrom, jokey, at, yarış, 4nala",
  },
  logout: {
    url: "/cikis-yap",
    title: "ÇIKIŞ YAP - 4NALA.COM, AT YARIŞI, BAHİS, AT YARIŞI SONUÇLARI, HİPODROM, AT YARIŞI PROGRAMI",
    description,
    keywords,
  },
  memberInfo: {
    url: "/uyelik-bilgilerim",
    title: "UYELİK BİLGİLERİM - 4NALA.COM, AT YARIŞI, BAHİS, AT YARIŞI SONUÇLARI, HİPODROM, AT YARIŞI PROGRAMI",
    description,
    keywords,
  },
  memberSessions: {
    url: "/oturumlarim",
    title: "UYELİK BİLGİLERİM - 4NALA.COM, AT YARIŞI, BAHİS, AT YARIŞI SONUÇLARI, HİPODROM, AT YARIŞI PROGRAMI",
    description,
    keywords,
  },
  notificationInfo: {
    url: "/bildirim-tercihlerim",
    title: "UYELİK BİLGİLERİM - 4NALA.COM, AT YARIŞI, BAHİS, AT YARIŞI SONUÇLARI, HİPODROM, AT YARIŞI PROGRAMI",
    description,
    keywords,
  },
  memberTickets: {
    url: "/biletlerim",
    title: "BİLETLERİM - 4NALA.COM, AT YARIŞI, BAHİS, AT YARIŞI SONUÇLARI, HİPODROM, AT YARIŞI PROGRAMI",
    description,
    keywords,
  },
  memberVirtualTickets: {
    url: "/sanal-oyun-biletlerim",
    title: "BİLETLERİM - 4NALA.COM, AT YARIŞI, BAHİS, AT YARIŞI SONUÇLARI, HİPODROM, AT YARIŞI PROGRAMI",
    description,
    keywords,
  },
  memberNumericTickets: {
    url: "/sayisal-oyun-biletlerim",
    title: "BİLETLERİM - 4NALA.COM, AT YARIŞI, BAHİS, AT YARIŞI SONUÇLARI, HİPODROM, AT YARIŞI PROGRAMI",
    description,
    keywords,
  },
  memberSavedTickets: {
    url: "/biletlerim/kayitli",
    title: "BİLETLERİM - 4NALA.COM, AT YARIŞI, BAHİS, AT YARIŞI SONUÇLARI, HİPODROM, AT YARIŞI PROGRAMI",
    description,
    keywords,
  },
  memberBankAccounts: {
    url: "/banka-hesaplarim",
    title: "BANKA HESAPLARIM - 4NALA.COM, AT YARIŞI, BAHİS, AT YARIŞI SONUÇLARI, HİPODROM, AT YARIŞI PROGRAMI",
    description,
    keywords,
  },
  memberTransactions: {
    url: "/hesap-hareketlerim",
    title: "HESAP HAREKETLERİM - 4NALA.COM, AT YARIŞI, BAHİS, AT YARIŞI SONUÇLARI, HİPODROM, AT YARIŞI PROGRAMI",
    description,
    keywords,
  },
  cookieSettings: {
    url: "/cerez-ayarlari",
    title: "HESAP HAREKETLERİM - 4NALA.COM, AT YARIŞI, BAHİS, AT YARIŞI SONUÇLARI, HİPODROM, AT YARIŞI PROGRAMI",
    description,
    keywords,
  },
  withdraw: {
    url: "/para-cek",
    title: "PARA ÇEK - 4NALA.COM, AT YARIŞI, BAHİS, AT YARIŞI SONUÇLARI, HİPODROM, AT YARIŞI PROGRAMI",
    description,
    keywords,
  },
  deposit: {
    url: "/para-yatir",
    title: "PARA YATIR - 4NALA.COM, AT YARIŞI, BAHİS, AT YARIŞI SONUÇLARI, HİPODROM, AT YARIŞI PROGRAMI",
    description,
    keywords,
  },
  support: {
    url: "/yardim-at-yarisi-bahis",
    title:
      "YARDIM, OYUN KURALLARI, NASIL AT YARIŞI KUPON YAPARIM - 4NALA.COM, AT YARIŞI, BAHİS, AT YARIŞI SONUÇLARI, HİPODROM, AT YARIŞI PROGRAMI",
    description,
    keywords,
  },
  announcement: {
    url: "/duyurulari-haberler",
    title:
      "DUYURULAR, HABERLER,  KOŞMAZ AT, YASAKLI JOKEYLER - 4NALA.COM, AT YARIŞI, BAHİS, AT YARIŞI SONUÇLARI, HİPODROM, AT YARIŞI PROGRAMI",
    description,
    keywords,
  },
  agreement: {
    url: "/sozlesmeler",
    title: "SÖZLEŞMELER - 4NALA.COM, AT YARIŞI, BAHİS, AT YARIŞI SONUÇLARI, HİPODROM, AT YARIŞI PROGRAMI",
    description,
    keywords,
  },
  notifications: {
    url: "/bildirimlerim",
    title: "BİLDİRİMLERİM - 4NALA.COM, AT YARIŞI, BAHİS, AT YARIŞI SONUÇLARI, HİPODROM, AT YARIŞI PROGRAMI",
    description,
    keywords,
  },
  flatpage: {
    url: "/fp",
    title: " 4NALA.COM, AT YARIŞI, BAHİS, AT YARIŞI SONUÇLARI, HİPODROM, AT YARIŞI PROGRAMI",
    description,
    keywords,
  },
  stream: {
    url: "/tv-atyarisi-izle-canli-yayin",
    title:
      "CANLI TV, AT YARIŞI İZLE CANLI YAYIN, - 4NALA.COM, AT YARIŞI, BAHİS, AT YARIŞI SONUÇLARI, HİPODROM, AT YARIŞI PROGRAMI",
    description,
    keywords,
  },
  tipsterCoupons: {
    url: "/hazir-kuponlar-yorumcular-at-yarisi-tahminleri",
    title: "HAZIR KUPONLAR - 4NALA.COM, AT YARIŞI, BAHİS, AT YARIŞI SONUÇLARI, HİPODROM, AT YARIŞI PROGRAMI",
    description:
      "At yarışı tahminci ve yorumcularının Hazır kuponları. Hazır 6lı kuponlar. AT YARIŞI sonuçları, at yarışı programı, hipodromlar ve daha fazlası için hemen ziyaret edin.",
    keywords:
      "6lı, altılı kuponlar, hazır kuponlar, at yarışı, at yarışı sonuçları, at yarışı programı, hipodrom, jokey, at, yarış, 4nala",
  },
  tipsterComments: {
    url: "/yorumlar-yorumcular-at-yarisi-tahminleri",
    title: "HAZIR KUPONLAR - 4NALA.COM, AT YARIŞI, BAHİS, AT YARIŞI SONUÇLARI, HİPODROM, AT YARIŞI PROGRAMI",
    description:
      "At yarışı tahminci ve yorumcularının Hazır kuponları. Hazır 6lı kuponlar. AT YARIŞI sonuçları, at yarışı programı, hipodromlar ve daha fazlası için hemen ziyaret edin.",
    keywords:
      "6lı, altılı kuponlar, hazır kuponlar, at yarışı, at yarışı sonuçları, at yarışı programı, hipodrom, jokey, at, yarış, 4nala",
  },
  register: {
    url: "/uye-ol",
    title: "HEMEN ÜYE OL - 4NALA.COM, AT YARIŞI, BAHİS, AT YARIŞI SONUÇLARI, HİPODROM, AT YARIŞI PROGRAMI",
    description:
      "4nala.com , eşsiz at yarışı deneyimi sunar. AT YARIŞI sonuçları, at yarışı programı, hipodromlar ve daha fazlası için hemen ziyaret edin.",
    keywords:
      "at yarışı, at yarışı sonuçları, at yarışı programı, hipodrom, jokey, at, yarış, 4nala",
  },
  resetPassword: {
    url: "/sifre-sifirla",
    title: "ŞİFREMİ UNUTTUM - 4NALA.COM, AT YARIŞI, BAHİS, AT YARIŞI SONUÇLARI, HİPODROM, AT YARIŞI PROGRAMI",
    description:
      "4nala.com , eşsiz at yarışı deneyimi sunar. AT YARIŞI sonuçları, at yarışı programı, hipodromlar ve daha fazlası için hemen ziyaret edin.",
    keywords:
      "at yarışı, at yarışı sonuçları, at yarışı programı, hipodrom, jokey, at, yarış, 4nala",
  },
  changePassword: {
    url: "/sifre-degistir",
    title: "ŞİFRE DEĞİŞTİR - 4NALA.COM, AT YARIŞI, BAHİS, AT YARIŞI SONUÇLARI, HİPODROM, AT YARIŞI PROGRAMI",
    description:
      "4nala.com , eşsiz at yarışı deneyimi sunar. AT YARIŞI sonuçları, at yarışı programı, hipodromlar ve daha fazlası için hemen ziyaret edin.",
    keywords:
      "at yarışı, at yarışı sonuçları, at yarışı programı, hipodrom, jokey, at, yarış, 4nala",
  },
  verifyEmail: {
    url: "/eposta-dogrula",
    title: "EPOSTA DOĞRULA - 4NALA.COM, AT YARIŞI, BAHİS, AT YARIŞI SONUÇLARI, HİPODROM, AT YARIŞI PROGRAMI",
    description:
      "4nala.com , eşsiz at yarışı deneyimi sunar. at yarışı sonuçları, at yarışı programı, hipodromlar ve daha fazlası için hemen ziyaret edin.",
    keywords:
      "at yarışı, at yarışı sonuçları, at yarışı programı, hipodrom, jokey, at, yarış, 4nala",
  },
  betting: {
    url: "/at-yarisi-bulteni-bahis-yap",
    title: "BAHİS YAP - AT YARIŞI, BAHİS, AT YARIŞI SONUÇLARI, HİPODROM, AT YARIŞI PROGRAMI",
    description:
      "4nala.com , eşsiz at yarışı deneyimi sunar. at yarışı sonuçları, at yarışı programı, hipodromlar ve daha fazlası için hemen ziyaret edin.",
    keywords:
      "at yarışı, at yarışı sonuçları, at yarışı programı, hipodrom, jokey, at, yarış, 4nala",
  },
  fobBetting: {
    url: "/at-yarisi-bulteni-sabit-ihtimalli-bahis-yap",
    title: "BAHİS YAP - AT YARIŞI, BAHİS, at yarışı sonuçları, HİPODROM, AT YARIŞI PROGRAMI",
    description:
      "4nala.com , eşsiz at yarışı deneyimi sunar. at yarışı sonuçları, at yarışı programı, hipodromlar ve daha fazlası için hemen ziyaret edin.",
    keywords:
      "at yarışı, at yarışı sonuçları, at yarışı programı, hipodrom, jokey, at, yarış, 4nala",
  },
  fobBetting2: {
    url: "/at-yarisi-bulteni-sabit-ihtimalli-bahis-yap-2",
    title: "BAHİS YAP - AT YARIŞI, BAHİS, at yarışı sonuçları, HİPODROM, AT YARIŞI PROGRAMI",
    keywords:
        "at yarışı, at yarışı sonuçları, at yarışı programı, hipodrom, jokey, at, yarış, 4nala",
  },
  longtermBetting: {
    url: "/at-yarisi-bulteni-uzun-vadeli-bahis-yap",
    title: "BAHİS YAP - AT YARIŞI, BAHİS, at yarışı sonuçları, HİPODROM, AT YARIŞI PROGRAMI",
    description:
        "4nala.com , eşsiz at yarışı deneyimi sunar. at yarışı sonuçları, at yarışı programı, hipodromlar ve daha fazlası için hemen ziyaret edin.",
    keywords:
        "at yarışı, at yarışı sonuçları, at yarışı programı, hipodrom, jokey, at, yarış, 4nala",
  },
  program: {
    url: "/at-yarisi-programi",
    title: "4NALA.COM, AT YARIŞI, BAHİS, at yarışı sonuçları, HİPODROM, AT YARIŞI PROGRAMI",
    description:
      "4nala.com , eşsiz at yarışı deneyimi sunar. at yarışı sonuçları, at yarışı programı, hipodromlar ve daha fazlası için hemen ziyaret edin.",
    keywords:
      "at yarışı, at yarışı sonuçları, at yarışı programı, hipodrom, jokey, at, yarış, 4nala",
  },
  results: {
    url: "/at-yarisi-sonuclari",
    title: "AT YARIŞI SONUÇLARI, AT YARIŞI, BAHİS, at yarışı sonuçları, HİPODROM, AT YARIŞI PROGRAMI",
    description:
      "4nala.com , eşsiz at yarışı deneyimi sunar. at yarışı sonuçları, at yarışı programı, hipodromlar ve daha fazlası için hemen ziyaret edin.",
    keywords:
      "at yarışı, at yarışı sonuçları, at yarışı programı, hipodrom, jokey, at, yarış, 4nala",
  },
  campaigns: {
    url: "/kampanyalar",
    title: "AT YARIŞI SONUÇLARI, AT YARIŞI, BAHİS, at yarışı sonuçları, HİPODROM, AT YARIŞI PROGRAMI",
    description:
      "4nala.com , eşsiz at yarışı deneyimi sunar. at yarışı sonuçları, at yarışı programı, hipodromlar ve daha fazlası için hemen ziyaret edin.",
    keywords:
      "at yarışı, at yarışı sonuçları, at yarışı programı, hipodrom, jokey, at, yarış, 4nala",
  },
  enhancements: {
    url: "/yenilikler",
    title: "AT YARIŞI SONUÇLARI, AT YARIŞI, BAHİS, at yarışı sonuçları, HİPODROM, AT YARIŞI PROGRAMI",
    description:
      "4nala.com , eşsiz at yarışı deneyimi sunar. at yarışı sonuçları, at yarışı programı, hipodromlar ve daha fazlası için hemen ziyaret edin.",
    keywords:
      "at yarışı, at yarışı sonuçları, at yarışı programı, hipodrom, jokey, at, yarış, 4nala",
  },
  reportedJokeys: {
    url: "/raporlu-cezalı-jokeyler",
    title: "AT YARIŞI SONUÇLARI, AT YARIŞI, BAHİS, at yarışı sonuçları, HİPODROM, AT YARIŞI PROGRAMI",
    description:
      "4nala.com , eşsiz at yarışı deneyimi sunar. at yarışı sonuçları, at yarışı programı, hipodromlar ve daha fazlası için hemen ziyaret edin.",
    keywords:
      "at yarışı, at yarışı sonuçları, at yarışı programı, hipodrom, jokey, at, yarış, 4nala",
  },
  horseStats: {
    url: "/kosmayan-atlar-jokey-degisikligi",
    title: "AT YARIŞI SONUÇLARI, AT YARIŞI, BAHİS, at yarışı sonuçları, HİPODROM, AT YARIŞI PROGRAMI",
    description:
      "4nala.com , eşsiz at yarışı deneyimi sunar. at yarışı sonuçları, at yarışı programı, hipodromlar ve daha fazlası için hemen ziyaret edin.",
    keywords:
      "at yarışı, at yarışı sonuçları, at yarışı programı, hipodrom, jokey, at, yarış, 4nala",
  },
  raffles: {
    url: "/sans-oyunlari/esya-piyangosu",
    title: "Eşya Piyangosu | Çekiliş | 4Nala",
    description:
      "4nala.com , eşsiz at yarışı deneyimi sunar. at yarışı sonuçları, at yarışı programı, hipodromlar ve daha fazlası için hemen ziyaret edin.",
    keywords:
      "at yarışı, at yarışı sonuçları, at yarışı programı, hipodrom, jokey, at, yarış, 4nala",
  },
  products: {
    url: "/sans-oyunlari/puan-donustur",
    title: "AT YARIŞI SONUÇLARI, AT YARIŞI, BAHİS, at yarışı sonuçları, HİPODROM, AT YARIŞI PROGRAMI",
    description:
      "4nala.com , eşsiz at yarışı deneyimi sunar. at yarışı sonuçları, at yarışı programı, hipodromlar ve daha fazlası için hemen ziyaret edin.",
    keywords:
      "at yarışı, at yarışı sonuçları, at yarışı programı, hipodrom, jokey, at, yarış, 4nala",
  },
  giftTicket: {
    url: "/hediye-biletler",
    title: "AT YARIŞI SONUÇLARI, AT YARIŞI, BAHİS, at yarışı sonuçları, HİPODROM, AT YARIŞI PROGRAMI",
    description,
    keywords,
  },
  statistics: {
    url: "/istatistikler",
    title: "AT YARIŞI SONUÇLARI, AT YARIŞI, BAHİS, at yarışı sonuçları, HİPODROM, AT YARIŞI PROGRAMI",
    description,
    keywords,
  },
  luckyGames: {
    url: "/sans-oyunlari",
    title: "Şans Oyunları | Şans Oyunları Oyna | 4Nala",
    description,
    keywords,
  },
  // sanal at yarışı
  vrhorseracing: {
    url: "/sanal-at-yarisi",
    title: "Sanal At Yarışı | Şans Oyunları | Sanal Oyunlar Oyna | 4Nala",
    description,
    keywords,
  },
  // sanal oyunlar
  vrgames: {
    url: "/sanal-oyunlar",
    title: "Sanal Oyunlar | Şans Oyunları | Sanal Oyunlar Oyna | 4Nala",
    description,
    keywords,
  },
  // sayısal oyunlar
  numericgames: {
    url: "/sayisal-oyunlar",
    title: "Sayısal Oyunlar | Şans Oyunları | Sayısal Oyunlar Oyna | 4Nala",
    description,
    keywords,
  },
  numerictickets: {
    url: "/sayisal-biletler",
    title: "Sayısal Oyunlar | Şans Oyunları | Sayısal Oyunlar Oyna | 4Nala",
    description,
    keywords,
  },
  sisalscratch: {
    url: "/kazi-kazan",
    title: "Şans Oyunları | Şans Oyunları Oyna | 4Nala",
    description:
        "4nala.com , eşsiz at yarışı deneyimi sunar. at yarışı sonuçları, at yarışı programı, hipodromlar ve daha fazlası için hemen ziyaret edin.",
    keywords:
        "at yarışı, at yarışı sonuçları, at yarışı programı, hipodrom, jokey, at, yarış, 4nala",
  },
  //   Oyunlar
  games: {
    url: "/sans-oyunlari",
    title: "Şans Oyunları | Şans Oyunları Oyna | 4Nala",
    description:
      "4nala.com , eşsiz at yarışı deneyimi sunar. at yarışı sonuçları, at yarışı programı, hipodromlar ve daha fazlası için hemen ziyaret edin.",
    keywords:
      "at yarışı, at yarışı sonuçları, at yarışı programı, hipodrom, jokey, at, yarış, 4nala",
  },
  fireballs: {
    url: "/sans-oyunlari/ates-toplari",
    title: "Ateş Topları | Şans Oyunları | Ateş Topları Oyna | 4Nala",
    description,
    keywords,
  },
  fruitTowers: {
    url: "/sans-oyunlari/meyve-kulesi",
    title: "Meyve Kulesi | Şans Oyunları | Meyve Kulesi Oyna | 4Nala",
    description,
    keywords,
  },
  turboMines: {
    url: "/sans-oyunlari/isiltili-taslar",
    title: "Işıltılı Taşlar | Şans Oyunları | Işıltılı Taşlar Oyna | 4Nala",
    description,
    keywords,
  },
  crashX: {
    url: "/sans-oyunlari/galaksi-turu",
    title: "Galaksi Turu | Şans Oyunları | Galaksi Turu Oyna | 4Nala",
    description,
    keywords,
  },
  turboPlinko: {
    url: "/sans-oyunlari/super-plinko",
    title: "Süper Plinko | Şans Oyunları | Süper Plinko Oyna | 4Nala",
    description,
    keywords,
  },
  hamsta: {
    url: "/sans-oyunlari/kunduzun-macerasi",
    title: "Kunduzun Macerası | Şans Oyunları | Kunduzun Macerası Oyna | 4Nala",
    description,
    keywords,
  },
  superWheel: {
    url: "/sans-oyunlari/super-carkifelek",
    title: "Çarkıfelek | Şans Oyunları | Çarkıfelek Oyna | 4Nala",
    description,
    keywords,
  },
  rockPaperScissors: {
    url: "/sans-oyunlari/tas-kagit-makas",
    title: "Taş Kağıt Makas | Şans Oyunları | Taş Kağıt Makas Oyna | 4Nala",
    description,
    keywords,
  },
  zeplin: {
    url: "/sans-oyunlari/zeplin",
    title: "Zeplin | Şans Oyunları | Zeplin Oyna | 4Nala",
    description,
    keywords,
  },
  superBingo: {
    url: "/sans-oyunlari/super-tombala",
    title: "Süper Tombala | Şans Oyunları | Süper Tombala Oyna | 4Nala",
    description,
    keywords,
  },
  millionShot: {
    url: "/sans-oyunlari/milyonluk-sut",
    title: "Milyonluk Şut | Şans Oyunları | Milyonluk Şut Oyna | 4Nala",
    description,
    keywords,
  },
  monkeyTreasure: {
    url: "/sans-oyunlari/maymun-hazinesi",
    title: "Maymun Hazinesi | Şans Oyunları | Maymun Hazinesi Oyna | 4Nala",
    description,
    keywords,
  },
  secretElements: {
    url: "/sans-oyunlari/gizli-elementler",
    title: "Gizli Elementler | Şans Oyunları | Gizli Elementler Oyna | 4Nala",
    description,
    keywords,
  },
  scratch: {
    url: "/sans-oyunlari/oyna-kazan",
    title: "Kazı Kazan | Şans Oyunları | Kazı Kazan Oyna | 4Nala",
    description,
    keywords,
  },
  scratchMyCards: {
    url: "/sans-oyunlari/oyna-kazan/kartlarim",
    title: "Kazı Kazan | Şans Oyunları | Kazı Kazan Oyna | 4Nala",
    description,
    keywords,
  },
  scartchRules: {
    url: "/sans-oyunlari/oyna-kazan/kurallar",
    title: "Kazı Kazan | Şans Oyunları | Kazı Kazan Oyna | 4Nala",
    description,
    keywords,
  },
  couponCode: {
    url: "/kupon-kodu",
    title: "Kupon Kodu | 4Nala",
    description,
    keywords,
  },
};

export default paths;
